<footer class="footer-static">

  <div class="row">
    <div class="col-md-7">
      Copyright © AFHunt Group 2014 - {{ currentYear }} <span class="fa fa-circle"></span>
      Made with <span class="fa fa-heart" style="color: #ff5406;"></span> by <a href="http://code.afhunt.com/" style="color: #ff5406;" target="_blank">AFH Code</a>
    </div>
    <div class="col-md-5 text-right">
      <a href="javascript:void(0)" routerLink="/public/cgu">CGU</a> | <a href="javascript:void(0)" routerLink="/public/confidentialite">Confidentialite</a> | <a href="#">Aide</a>
    </div>
  </div>

</footer>
